import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { Slide, SlideProps } from "@mui/material";

interface CustomModalProps {
  isOpen: boolean;
  setIsOpen: (arg0: boolean) => void;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  title: string;
  content: any;
  size?: "xs" |"sm" | "md" | "lg" | "xl";
}

const CustomModal: React.FC<CustomModalProps> = ({
  isOpen,
  setIsOpen,
  maxWidth,
  title,
  content,
  size = "md",
}) => {
  const sx = {
    "& .MuiDialog-container": {
      marginTop: "-2vh",
    },
  };

  const determineMaxWidth = (): "xs" | "sm" | "md" | "lg" | "xl" => {
    switch (size) {
      case "xs":
        return "xs";
      case "sm":
        return "sm";
      case "md":
        return "md";
      case "lg":
        return "lg";
      case "xl":
        return "xl";
      default:
        return "md";
    }
  };

  return (
    <>
      <Dialog
        TransitionComponent={Transition}
        fullWidth
        maxWidth={determineMaxWidth() || maxWidth}
      open={isOpen}
        onClose={() => setIsOpen(false)}
        sx={sx}
      >
        <DialogTitle
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingBottom: "0.5rem",
            borderBottom: "1px solid darkgray",
            color: "black",
            fontSize: "17px",
            fontWeight: "bold",
          }}
        >
          <div>{title}</div>
          <Button
            onClick={() => setIsOpen(false)}
            style={{
              justifyContent: "right",
            }}
          >
            <CloseOutlinedIcon style={{ color: "#355d9a" }} />
          </Button>
        </DialogTitle>
        <DialogContent style={{ padding: "1rem" }}>{content}</DialogContent>
      </Dialog>
    </>
  );
};

const Transition = React.forwardRef(function Transition(
  props: SlideProps & { children: React.ReactElement },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default CustomModal;
